import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["onClick"]

import { computed } from 'vue'
import Category from '../../models/category'
import Exam from '../../models/exam'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ExamListCategory'
},
  __name: 'ExamListCategory',
  props: {
    category: {},
    padding: { default: 0 },
    isCategoryRoot: { type: Boolean, default: true },
    showEmpty: { type: Boolean, default: false },
    exams: { default: () => [] }
  },
  emits: ["clickCategory"],
  setup(__props: any, { emit: __emit }) {



const props = __props

const emit = __emit

const categoryExams = computed(() => {
  return props.category.getExams(props.exams)
})

const clickCategory = (category: Category) => {
  emit('clickCategory', category)
}

const categoryHasExam = computed(() => {
  return props.category.children.filter((x) => x.examsCount > 0)
})

return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_ExamListCategory = _resolveComponent("ExamListCategory", true)!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_group = _resolveComponent("v-list-group")!

  return (__props.category.examsCount > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_list_group, {
          modelValue: __props.category.isRoot,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.category.isRoot) = $event))
        }, _createSlots({
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryHasExam.value, (subCategory) => {
              return (_openBlock(), _createBlock(_component_v_list_item, {
                key: subCategory.name?.toString()
              }, {
                default: _withCtx(() => [
                  (subCategory.children.length == 0 && subCategory.examsCount > 0 )
                    ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                        key: 0,
                        style: _normalizeStyle(`padding-left:${__props.padding}px`)
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (clickCategory(subCategory))
                          }, _toDisplayString(subCategory.name) + " " + _toDisplayString(subCategory.examsCount > 0 ? `(${subCategory.examsCount})` : ''), 9 /* TEXT, PROPS */, _hoisted_2)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["style"]))
                    : (_openBlock(), _createBlock(_component_ExamListCategory, {
                        key: 1,
                        exams: __props.exams,
                        "show-empty": true,
                        category: subCategory,
                        isCategoryRoot: false,
                        padding: 16,
                        onClickCategory: clickCategory
                      }, null, 8 /* PROPS */, ["exams", "category"]))
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 2 /* DYNAMIC */
        }, [
          (__props.isCategoryRoot)
            ? {
                name: "activator",
                fn: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (clickCategory(__props.category))),
                        class: _normalizeClass(`root-class`)
                      }, _toDisplayString(__props.category.name) + " " + _toDisplayString(__props.category.examsCount > 0 ? `(${__props.category.examsCount})` : ''), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                key: "0"
              }
            : {
                name: "activator",
                fn: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (clickCategory(__props.category))),
                        class: _normalizeClass(__props.category.name)
                      }, _toDisplayString(__props.category.name) + " " + _toDisplayString(__props.category.examsCount > 0 ? `(${__props.category.examsCount})` : ''), 3 /* TEXT, CLASS */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                key: "1"
              }
        ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue"])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})